// src/components/reports/survey/SurveyDynamics.tsx
import React from "react";

interface SurveyRow {
  measured_depth: string | number;
  inclination: string | number;
  azimuth: string | number;
  tvd: string | number;
  Vertical_Section: string | number;
  latitude: string | number;
  departure: string | number;
  DLS: string | number;
}

interface JobDetails {
  [key: string]: any;
}

interface FooterData {
  [key: string]: any;
}

interface SurveyDynamicsProps {
  row_length: number;
  sur_lengths: number[];
  survey_row_details: SurveyRow[];
  job_details: JobDetails;
  footer_data: FooterData;
  calculateIndex: (
    sur_lengths: number[],
    index: number,
    offset: number
  ) => number;
  showTieOn?: boolean; // 👈 controls Tie-on display
  tieOnData?: SurveyRow; // 👈 Add tie-on data prop
  isFirstPage?: boolean;
  pageNo?: number; 
}

const ReportFooter: React.FC<{ footer_data: FooterData; page_no: number }> = ({
  footer_data,
  page_no,
}) => {
  return (
    <div className="report-footer text-[10pt] text-gray-600 mt-2 flex justify-end pr-4">
      Page {page_no}
    </div>
  );
};

const SurveyDynamics: React.FC<SurveyDynamicsProps> = ({
  row_length,
  sur_lengths,
  survey_row_details,
  footer_data,
  calculateIndex,
  showTieOn = false,
  tieOnData, // 👈 Receive tie-on data
  isFirstPage = false, // 👈 Default to false
}) => {
  const columns = [
    ["MD", "(m)"],
    ["Inclination", "(degs)"],
    ["Azimuth", "(degs)"],
    ["TVD", "(m)"],
    ["V.S.", "(m)"],
    ["+N/-S", "(m)"],
    ["+E/-W", "(m)"],
    ["DLS", "(°/30)"],
  ];
  console.log(survey_row_details)

  return (
    <>
    
      {row_length > 0 &&
        sur_lengths.map((si, si_index) => (
          <div
            key={si_index}
            className="  !bg-white flex flex-col overflow-hidden"
          >
            {/* Table */}
            <div className="flex-grow mt-.5 pl-1 px-.5 overflow-hidden">
              <table className="table-fixed min-w-full border-collapse text-center">
                <thead>
                  <tr className="bg-gray-500 text-white text-[9.5pt] h-[7.937mm]">
                    {columns.map(([title, unit], idx) => (
                      <th
                        key={idx}
                        className="border-r-[0.75pt] border-white font-normal w-[12.5%]"
                      >
                        <div>{title}</div>
                        <div>{unit}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                
                <tbody>
                  {/* Tie-on Section - Show only on first page */}
                  {/* {isFirstPage && tieOnData && (
                    <>
                      <tr>
                        <td
                          colSpan={8}
                          className="text-red-600 text-[10pt] italic text-left pl-2 pt-1 bg-gray-100"
                        >
                          Tie-on Surveys
                        </td>
                      </tr>
                      
                      {/* Tie-on Data Row */}
                      {/* <tr className="text-[9pt] bg-gray-200">
                        {columns.map((col, idx) => (
                          <td
                            key={idx}
                            className="border border-white px-1 py-[1.2px] text-center align-middle font-semibold"
                          >
                            {Object.values(tieOnData)[idx] || "-"}
                          </td>
                        ))}
                      </tr> */}
                      
                      {/* Row Gap after Tie-on */}
                      {/* <tr>
                        <td colSpan={8} className="h-[15px] bg-white"></td>
                      </tr>
                    </>
                  )}  */}

                  {/* Render regular survey rows */}
                  {survey_row_details.map((row, row_index) => (
                    <React.Fragment key={row_index}>
                      <tr
                        className={`text-[9pt] ${
                          row_index % 2 === 0 ? "bg-white" : "bg-gray-200"
                        }`}
                        style={{ height: "6.35mm" }}
                      >
                        {Object.values(row).map((val, idx) => (
                          <td
                            key={idx}
                            className=" text-center align-middle"
                          >
                            {val}
                          </td>
                        ))}
                      </tr>

                      
                      {(row_index + 1) % 5 === 0 && (
                        <tr>
                          <td colSpan={8} className="bg-white" style={{ height: "10pt" }}></td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer pinned at bottom */}
           
          </div>
        ))}
    </>
  );
};

export default SurveyDynamics;